import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ShortUrl } from '@air/api';
import {
  contentCollectionFormSelector,
  contentCollectionSessionIdSelector,
  setSessionIdAction,
} from '@air/feature-content-collection/redux';
import { useShortIdContext } from '@air/provider-short-id';

import { useAirStore } from '~/utils/ReduxUtils';

export function useGetContentCollectionSessionId() {
  const dispatch = useDispatch();
  const store = useAirStore();
  const { shortId } = useShortIdContext();
  const form = useSelector(contentCollectionFormSelector);

  const getSessionId = useCallback(async () => {
    let sessionId = contentCollectionSessionIdSelector(store.getState());

    if (!sessionId) {
      const { id } = await ShortUrl.createFormSession({ shortId, formId: form.id });

      dispatch(setSessionIdAction({ sessionId: id }));

      sessionId = id;
    }

    return { sessionId };
  }, [dispatch, form, shortId, store]);

  return { getSessionId };
}
